<template>
    <div class="container">
        <div class="row justify-content-center mt-md-5">

            <connection-api-test-component
                v-if="this.$store.state.errorMessageResponse" :messageResponse="this.$store.state.errorMessageResponse">
            </connection-api-test-component>

            <div class=" col-md-9  col-xl-6 ">
                <div class="card mt-5">
                    <div class="card-header">LOGIN</div>

                    <div class="card-body">
                        <form method="POST" action="" @submit.prevent="login($event)">
                            <input type="hidden" name="_token" :value="csrf_token">


                            <div class="row mb-3">
                                <label for="email" class="col-md-4 col-form-label text-md-end">Email de login</label>
                                <div class="col-md-6">
                                    <input id="email" class="form-control" name="email" value="" autocomplete="email" autofocus v-model="email">

                                    <alert-error-message-component v-if="this.errors.email" :mesage="errors.email">
                                    </alert-error-message-component>


                                    <alert-error-message-component v-if="this.errors.invalid_credentials && !this.errors.email"  :mesage="errors.invalid_credentials">
                                    </alert-error-message-component>

                                </div>
                            </div>

                            <div class="row mb-3">
                                <label for="password" class="col-md-4 col-form-label text-md-end">Senha</label>

                                <div class="col-md-6">
                                    <input id="password" type="password"
                                           class="form-control" name="password"
                                            autocomplete="current-password" v-model="password">

                                    <alert-error-message-component v-if="errors.password"  :mesage="errors.password">
                                    </alert-error-message-component>

                                </div>
                            </div>


                            <div class="row mb-0">
                                <div class="col-md-8 offset-md-4">
                                    <button type="submit" class="btn btn-primary">
                                        Logar
                                    </button>

                                    <a class="btn btn-link" href=""  @click.prevent="openRemenberPassword()">Esqueceu sua senha?</a>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['api_url', 'csrf_token','remember_password', 'rote_login'],

    data() {
        return {
            email: '',
            password: '',
            status : '',
            errors : {
                'email' : '',
                'password': '',
                'invalid_credentials' : '',
            },
        }
    },

    methods: {
        login(e) {

            this.$store.state.errorMessageResponse = '';

            if(!this.validaForm()){
              return;
            }

            let formData = new FormData();
            formData.append('email', this.email)
            formData.append('password', this.password)

            let url = this.rote_login

            axios.post(url, formData)
                .then(response => {
                    this.errors.invalid_credentials =  ''
                    this.status = 'success'

                    if(!response.data.status ){
                       this.errors.invalid_credentials =  response.data.message
                    }else{
                        e.target.submit();
                    }


                })
                .catch(error =>{
                    this.errors.email = '';
                    this.errors.password = '';
                    this.status = 'error'

                    this.$store.state.errorMessageResponse = error.message;


            })

        },

        validaForm() {
            if(this.email === ''){
                this.errors.email = 'O campo email é obrigatório'
                return false;
            }else{
                this.errors.email = ''
            }

            if(this.password === ''){
                this.errors.password = 'O campo senha é obrigatório'
                return false;
            }else{
                this.errors.password = ''
            }

            return true
        },

        openRemenberPassword(){
            document.location.href =  this.remember_password;
        },
    },

    mounted() {
        console.log(this.rote_login)
    }


}
</script>

